export const ORDER_DETAIL = 'v1/order/vp/coupon/package/detail'
export const ORDER_LIST = 'v1/order/vp/coupon/package/list'
export const VIRTUAL_PRODUCT_LIST = 'vproduct/launch/product/list'
export const VOUCHER_UPGRADE_URL = 'interests/upgraderelation/upgrade'
